import c from "../common";

export default {
  earnLocation: "Location",
  earnMethod: "Method",
  pointBelongToVendor: "Belongs to",

  livePurchase: "earn",
  buyVoucher: c.voucher.en.lowercase,
  assistant: c.assistant.en.uppercase,
  //
  text1: "Earning Record"
};
